export default {"src":"/_next/static/media/arrow-img.90c6f0ef.svg","height":22,"width":13};